import React from 'react';
import { Box, Container, Grid, Typography, useTheme } from '@mui/material';

export const ProcessTimeline: React.FC = () => {
  const theme = useTheme();

  const steps = [
    {
      step: '01',
      title: 'Understand',
      desc: 'Requirements & BOQ Analysis',
      active: true,
    },
    {
      step: '02',
      title: 'Plan',
      desc: 'Procurement & Site Logistics',
      active: false,
    },
    {
      step: '03',
      title: 'Execute',
      desc: 'Precision On-site Installation',
      active: false,
    },
    {
      step: '04',
      title: 'Control',
      desc: 'QA/QC & Safety Audits',
      active: false,
    },
    {
      step: '05',
      title: 'Deliver',
      desc: 'Final Handover & Compliance',
      active: false,
    },
  ];

  return (
    <Box
      id="process"
      sx={{
        py: { xs: 10, md: 14 },
        backgroundColor: theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '2.75rem' },
              color: theme.palette.text.primary,
              fontFamily: 'Space Grotesk',
              fontWeight: 700,
              mb: 1.5,
            }}
          >
            Our Methodology
          </Typography>
          <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
            A structured workflow for complex project delivery.
          </Typography>
        </Box>

        <Box sx={{ position: 'relative' }}>
          <Grid container spacing={3} sx={{ position: 'relative', zIndex: 1 }}>
            {steps.map((item, index) => (
              <Grid item xs={12} sm={6} md={2.4} key={index} sx={{ position: 'relative' }}>
                <Box sx={{ textAlign: 'center', p: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: '50%',
                      backgroundColor: theme.palette.background.paper,
                      border: item.active ? `2px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.divider}`,
                      color: item.active ? theme.palette.primary.main : theme.palette.text.primary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      fontWeight: 700,
                      fontFamily: 'Space Grotesk',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    {item.step}
                  </Box>

                  <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontFamily: 'Space Grotesk', fontWeight: 600, mb: 1 }}>
                    {item.title}
                  </Typography>

                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
                    {item.desc}
                  </Typography>
                </Box>

                {/* Hyphen '-' Separator: Very light color almost blending into background */}
                {index < steps.length - 1 && (
                  <Box
                    component="span"
                    aria-hidden="true"
                    sx={{
                      display: {
                        xs: 'none',
                        sm: index % 2 === 0 ? 'block' : 'none',
                        md: 'block',
                      },
                      position: 'absolute',
                      top: '50%',
                      right: '-12px',
                      transform: 'translate(50%, -50%)',
                      color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.18)' : 'rgba(0, 0, 0, 0.14)',
                      fontWeight: 500,
                      fontSize: '1.5rem',
                      lineHeight: 1,
                      userSelect: 'none',
                      zIndex: 2,
                    }}
                  >
                    -
                  </Box>
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ProcessTimeline;
